import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

export enum AlertIntent {
  INFO = 'information',
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
}

export type AlertOptions = {
  intent?: AlertIntent;
  intentIcon?: string;
  description?: string;
  buttonLabel?: string;
  hasClose?: boolean;
  duration?: number;
};

@Component({
  moduleId: module.id,
  selector: 'alert',
  templateUrl: './alert.component.html',
})
export class AlertComponent implements OnInit {
  @Input() isOpen: boolean = false;
  /**
   * The type of feedback
   */
  @Input() intent: string = AlertIntent.WARNING;
  /**
   * Icon that conveys the intent in a visual manner
   */
  @Input() intentIcon = 'exclamation';
  /**
   * The title of the message
   */
  @Input() hasCloseButton = false;

  @Input() isPopOver: boolean = false;

  @Output() onClose: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  customClose() {
    this.onClose.emit();
  }
}
